module.exports = __webpack_public_path__ + "img/FR10207.c82b3c43.png";